import { render, staticRenderFns } from "./GExamCreateConfirmViewItemCell.vue?vue&type=template&id=9635d634&scoped=true&"
import script from "./GExamCreateConfirmViewItemCell.vue?vue&type=script&lang=ts&"
export * from "./GExamCreateConfirmViewItemCell.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9635d634",
  null
  
)

export default component.exports